export default "__VITE_ASSET__BNUEYYFU__"